module.exports = __webpack_public_path__ + "static/media/slider_1_en_sm.0f870903.svg";